export const data = {
    menus: [
        {name: '首页', code: 'home', route: 'home'},
        {name: '企业简介', code: 'company', route: 'company'},
        {name: '产品介绍', code: 'product', route: 'product'},
        {name: '技术支持', code: 'patent', route: 'patent'},
        {name: '联系我们', code: 'about', route: 'about'},
    ],

    productMenu: '产品介绍',
    home: {
        title1: '华仁健康',
        content1: '“华”取自于华夏文明、华夏民族，代表中华民族之生生不息;',
        content2: '“仁”取自儒家思想的核心，道德的最高原则;',
        content3: '“健康”来自赋予思想的生命延续，覆盖所有物质、精神世界。',
    },

    company: {
        title1: '品牌起源',
        content1: ' <p>\n' +
        '                            从物种起源那一刻起,“生命”踏上历史舞台。</p>\n' +
        '                        <p>人类，万物生灵的一支，经过进化式的繁衍生息得以存活。8000年前，华夏人在黄河流域开启了华夏文明。生存被赋予了诸多要素，华夏文明、华夏民族可以延续，我们有了今天的生活。\n' +
        '                            生活离不开健康，健康涵盖了生活的方方面面。</p>\n' +
        '                        <p>“健康”已经演变成对生活方式和生活态度的向往，是生活质量的象征。“健康”在财富之上，在灵魂之中，在时间之恒，在境界之胜，在道德之仁。</p>\n' +
        '                        <p>\n' +
        '                            “华仁健康”</p>\n' +
        '                        <p>“华”取自于华夏文明、华夏民族，代表中华民族之生生不息；</p>\n' +
        '                        <p>“仁”取自儒家思想的核心，道德的最高原则；</p>\n' +
        '                        <p>“健康”来自赋予思想的生命延续，覆盖所有物质、精神世界。\n' +
        '\n' +
        '                        </p>',

        title2: '企业简介',
        content2: '<p>\n' +
        '\n' +
        '                            河南华仁健康科技有限公司成立于2016年，坐落于郑州高新技术开发区,是一家专注于以“健康”为主线的各类产品的研发、生产、销售及售后服务为一体的高新技术密集型企业。</p>\n' +
        '                        <p>\n' +
        '                            公司产品以科学仪器、医疗检测产品为基础形成饮食健康系列、医疗健康系列。饮食健康系列分为食品、农产品、粮油、水质四种快速检测方案、样品前处理方案以及充分发挥农业科学的健康食品；医疗健康系涵盖微量元素检测仪、样本稀释液两大类产品。公司拥有一批在科学仪器与医疗检测行业有数十年研发经验和深刻理解的研发精英。在北京海淀区这块极具科技底蕴的科技产品孵化园内拥有独立研发中心。华仁健康公司销售、服务体系遍布全国，由来自全国各地的科学仪器、医疗检测资深销售及服务人才组成。</p>\n' +
        '                        <p>\n' +
        '                            2018年初，公司与中国农业大学理学院建立战略合作伙伴关系，成功引入国家级获奖项目：农产品检测样品农药残留前处理过程中所需高效净化柱（固相萃取柱）的生产。此项独特前处理方法及其方法中的核心产品高效净化柱的生产引入，成功填补了国内此项领域的空白。公司秉承“科学”、“人性化”的管理理念，建立了完整、高效的管理团队，将研发、生产、销售、计财有机融合。公司致力于全系产品的智能化、快速化和集成化，为民众健康事业提供高效、便捷的产品和服务。\n' +
        '                        </p>'
    },

    product1: {
        title: 'Quick PRO ™️系列净化柱',
        content: " <p class=\"indent25\">\n" +
        "                        Quick PRO ™系列净化柱产品源于中国农业大学潘灿平教授研究组科研成果的专利转化，该研究组研究了多壁碳纳米管等固相材料作为分散萃取的净化效果，并首次开发出基于“QuEChERs”法的高效快捷的滤过型固相净化方法（m-PFC法），在近百种农药、多种兽药、毒素和各种代表性基质上得到了验证，方法参数如回收率、重现性、检出限等方面能够达到农药残留、兽药残留、毒素分析的要求。与经典的QuEChERS方法比较，在应用范围、干扰物质去除、基质效应、实验成本等方面有明显优势。符合国标GB 23200.113-2018 食品安全国家标准 植物源性食品中208种农药及其代谢物残留量的测定  气相色谱-质谱联用法。\n" +
        "                    </p>\n" +
        "                    <p>Quick PRO ™系列净化柱特点：\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        基于“QuEChERs”方法，华仁健康Quick PRO ™系列净化柱100%转化中国农业大学潘灿平教授研究组专利，此系列产品方便快速、特异性强、可靠性好、扩展性强性价比高等特点得到了广大使用单位的好评。该产品有以下三大核心亮点：\n" +
        "                    </p>\n" +
        "                    <p>（1）拥有专利的滤过性净化柱(m-pfc)滤过净化形式\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        将QuEChERS方法中分散固相萃取中的吸附剂装填至固相萃取柱管内，此类萃取柱为滤过性固相净化柱（multiplug filtration clean-up,m-PFC）该方法可以显著提高残留分析方法前处理效率和净化效果，为农、兽药等痕量分析开拓了一个新的研究方向，该方法在2015年获得了国家发明专利证书。\n" +
        "                    </p>\n" +
        "                    <p>（2）多壁碳纳米管（MWCNTs）\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        在吸附材料中加入修饰的多壁碳纳米管（MWCNTs），具有较大的比表面积，净化效果显著优于传统固相材料。同时将“QuEChERs”方法中的PSA、C18、弗罗里硅土等多种吸附剂混合使用，使得对基质中的色素、有机酸、脂肪酸、碳水化合物等都有较好的吸附。\n" +
        "                    </p>\n" +
        "                    <p>（3）涵盖性\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">植物源性食品、动物源性食品如牛肉、猪肉、羊肉及肾脏、牛奶、鸡蛋等\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\"> 分析目标物：农药残留、兽药残留，如氯霉素、磺胺类、阿维菌素类和毒素\n" +
        "                    </p>\n" +
        "                    <table class=\"pTable\">\n" +
        "                        <tr>\n" +
        "                            <td style=\"width: 150px;font-weight: 600;font-size: 14px;\">型号</td>\n" +
        "                            <td style=\"width: 450px;text-align: center;font-weight: 600;font-size: 14px;\">描述</td>\n" +
        "                            <td style=\"width: 100px;font-weight: 600;font-size: 14px;\">包装</td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-PP</td>\n" +
        "                            <td>\n" +
        "                                <p>适用于含水量大、含糖量高、色素较低的简单基质样品中农药残留的检测</p>\n" +
        "                                <p>适用样品：苹果、梨、桃、黄瓜、空心菜等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-CP</td>\n" +
        "                            <td>\n" +
        "                                <p>适用于含有大量色素及干扰物质的复杂基质样品中农药残留的检测</p>\n" +
        "                                <p>适用样品：菠菜、韭菜、芹菜、茶叶、咖啡、土壤等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-HF</td>\n" +
        "                            <td>\n" +
        "                                <p>适用于富含油脂、淀粉、蛋白质等的植物源样品及各类动物源样品中农药残留的检测</p>\n" +
        "                                <p>适用样品：大豆、花生、肉类、内脏、蛋类、水产品、乳制品等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-VD</td>\n" +
        "                            <td>\n" +
        "                                <p>适用于动物源样品中兽药残留的检测</p>\n" +
        "                                <p>适用样品：猪、牛、羊、家禽、水产品、乳制品等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                    </table>\n" +
        "                    <div style=\"line-height: 10px;\">\n" +
        "                        <p> 应用领域 ：\n" +
        "                        </p>\n" +
        "                        <div style=\"padding-left: 25px;\">\n" +
        "                            <p> 食品所（检测中心）：流通领域的食品中农药残留的检测\n" +
        "                            </p>\n" +
        "                            <p> 农产品检测中心：农产品农药残留的检测\n" +
        "                            </p>\n" +
        "                            <p> 农业环境监测中心：农产品农药残留的检测\n" +
        "                            </p>\n" +
        "                            <p> 畜产品检测中心：畜产品中农药残留、兽药残留的检测\n" +
        "                            </p>\n" +
        "                            <p> 水产品检测中心：水产品中兽药残留的检测\n" +
        "                            </p>\n" +
        "                            <p>CDC：食品、餐饮风险监控\n" +
        "                            </p>\n" +
        "                            <p>农科院、各类高校及科研院所：农药残留、兽药残留、毒素的检测及科研\n" +
        "                            </p>\n" +
        "                            <p>粮油检测中心：粮食中农药残留的检测\n" +
        "                            </p>\n" +
        "                            <p>乳制品企业：乳制品中兽药残留的检测\n" +
        "                            </p>\n" +
        "                            <p> 第三方检测公司：各类型样品的农药残留、兽药残留、毒素的检测\n" +
        "                            </p></div>\n" +
        "                    </div>"
    },

    patent: {
        row1: '技术文档下载',
        row2: '技术交流请致函：support@hrjktech.com'
    },
    product2: {
        building: '正在建设中，敬请期待',
        title: '样本稀释液产品',
        name1: '全血多元素检测专用样本稀释液',
        content1: '微量元素检测是通过原子吸收法仪器检查检查人体血液中微量元素的多少。现代科学研究证明，微量元素在人体中起着极其重要的作用，它的缺乏和过剩与人类的健康休戚相关。',

        name2: '全血铅镉元素检测专用样本稀释液',
        content2: '少儿智力发育障碍及多动症与人体中微量元素铅、镉关系密切；且营养不良儿童与铜、锌、钙、镁、铁元素缺乏有密切关系。'
    },

    products: [
        {name: '饮食健康', code: 'product1', route: 'product1'},
        {name: '医疗健康', code: 'product2', route: 'product2'}
    ],

    bottom: {
        address: '地址：中国河南郑州高新技术产业开发区长椿路11号国家大学科技园C2-B3',
        phone: '联系电话：86-371-63350191',
        email: '邮箱：support@hrjktech.com',
        company: '版权所有2018河南华仁健康科技有限公司保留一切权利',
        no: '豫ICP备18031691号',
        yyzz: '营业执照',
        content: '经过两年的建设和维护，河南华仁健康已经在全国建立了以北京为应用中心，郑州为销售中心的全国销售、服务、应用支持网络，网络遍及吉林、辽宁、北京、天津、内蒙、山西、河北、河南、山东、安徽、江苏、上海、浙江、湖北、湖南、江西、福建、广东、广西、海南、陕西、甘青宁、四川、云南、贵州、西藏省、市、自治区。'
    },
    attrs: [{
        name: '净化效果图：视觉、回收率（农药列表、兽药）、图谱.pdf',
        href: './static/1.pdf'
    },
        {
            name: '净化柱不同基质前处理注意事项.pdf',
            href: './static/2.pdf'
        },
        {
            name: '净化柱参考文献.pdf',
            href: './static/3.pdf'
        },
        {
            name: 'QuickPRO系列净化柱使用示意图.pdf',
            href: './static/4.pdf'
        }]
}



// WEBPACK FOOTER //
// ./src/assets/data/zh_cn.js